export enum TypeOfDate {
  DAILY = 'daily',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
  LASTSEVEN = 'lastSeven'
}
